import { OrButtonV2 as OrButton, OrIcon, OrOverflowMenu } from '@onereach/ui-components-legacy';
import { defineComponent } from 'vue';
import { ExportFormats } from '@/constants';
export default defineComponent({
    name: 'ContactsExportMenu',
    components: {
        OrButton,
        OrIcon,
        OrOverflowMenu,
    },
    props: {
        count: {
            type: Number,
            required: false,
            default: () => null,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['export'],
    setup(props, { emit }) {
        return {
            items: [
                {
                    label: '.CSV',
                    handler: () => emit('export', ExportFormats.CSV),
                },
                {
                    label: '.JSON',
                    handler: () => emit('export', ExportFormats.JSON),
                },
            ],
        };
    },
});
